if (!customElements.get('blog-reading-progress')) {
  customElements.define(
    'blog-reading-progress',
    class BlogReadingProgress extends HTMLElement {
      connectedCallback() {
        // The read runs from the start of the post body to the end of the last
        // blog content section below it (Energy flow, NAD+ loss, ...), so
        // those sections count towards the progress too.
        this.start = document.querySelector('.article-template__content') || document.querySelector('.article-template');
        const sections = document.querySelectorAll('.blog-explainer');
        this.end = sections.length ? sections[sections.length - 1].closest('.shopify-section') || sections[sections.length - 1] : this.start;
        this.bar = this.querySelector('.blog-reading-progress__bar');
        if (!this.start || !this.bar) return;

        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const top = this.start.getBoundingClientRect().top;
        const bottom = this.end.getBoundingClientRect().bottom;
        // 0 when the body's top reaches the top of the screen, 1 when the end of the last section reaches the bottom.
        const scrollable = bottom - top - window.innerHeight;
        const progress = scrollable > 0 ? -top / scrollable : top <= 0 ? 1 : 0;
        this.bar.style.transform = `scaleX(${Math.min(Math.max(progress, 0), 1)})`;
      }
    }
  );
}
